module.exports = (url, callback) => {
    var script = document.createElement("script");
    script.type = "text/javascript";

    if (script.readyState) {  // IE
        script.onreadystatechange = function () {
            if (script.readyState == "loaded" || script.readyState == "complete") {
                script.onreadystatechange = null;
                callback && callback(false, url);
            }
        };
    } else {  //Others
        script.onload = function () {
            callback && callback(false, url);
        };
    }

    script.onerror = function () {
        callback && callback(true, url);
    };

    script.src = url;
    document.getElementsByTagName("head")[0].appendChild(script);
};



/** WEBPACK FOOTER **
 ** ../src/common/loadScript.js
 **/